<div class="header-container">
  <div id="bloc1" class="block1">
    <span>
      <mat-icon class="s-icon"> person </mat-icon>
    </span>
    <span class="hide-text-lebel"> User Management </span>
  </div>
  <div id="bloc2" class="block2">
    <input
      class="search-bar"
      type="search"
      aria-label="search"
      placeholder="Search"
      [(ngModel)]="searchText"
      (ngModelChange)="onSearch($event)"
    />
  </div>
</div>

<div>
  <mat-tab-group
    [selectedIndex]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
  >
    <mat-tab *ngFor="let tab of tabs; let index = index" [label]="tab">
      <div
        *ngIf="activTab == 'Create User'"
        style="margin: 0 auto"
        class="dropdpwn-header-container"
      >
        <span id="test2" class="select-role" *ngIf="userRole == 'root'">
          <mat-form-field appearance="fill">
            <mat-label>Select Role</mat-label>
            <mat-select
              [(value)]="slelcted"
              (selectionChange)="onSelectCeateUser($event)"
            >
              <mat-option *ngFor="let data of filterRole" [value]="data">
                {{ data }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>

        <span
          id="test1"
          class="select-company"
          style="width: 30%"
          *ngIf="userRole == 'root'"
        >
          <mat-form-field appearance="fill">
            <mat-label>Select Company</mat-label>
            <mat-select
              [(ngModel)]="selectedCompanyForFilter"
              (selectionChange)="onSelectcompany($event)"
              required
              [disabled]="disableCompanyDropdown"
            >
              <mat-option *ngFor="let data of companyList" [value]="data">
                {{ data.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>

        <span id="test3" class="full-text" *ngIf="userRole == 'root'">
          <button
            (click)="openDialog('new')"
            [disabled]="
              selectedCompanyForFilter == null || selectedCompanyForFilter == ''
            "
            mat-raised-button
          >
            New User
          </button>
        </span>
        <span
          id="test3"
          class="full-text"
          *ngIf="userRole == 'admin' || userRole == 'manager'"
        >
          <button (click)="openDialog('new')" mat-raised-button>
            New User
          </button>
        </span>
      </div>

      <div
        *ngIf="activTab == 'Filter Users'"
        style="margin: 0 auto"
        class="dropdpwn-header-container"
      >
        <span
          id="test1"
          class="select-company"
          style="width: 30%"
          *ngIf="userRole == 'root'"
        >
          <mat-form-field appearance="fill">
            <mat-label>Select Company</mat-label>
            <mat-select
              [(value)]="selectedCompanyFilter"
              (selectionChange)="onSelectcompanyFilter()"
            >
              <mat-option *ngFor="let data of companyList" [value]="data">
                {{ data.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>

        <span
          id="test2"
          class="select-role"
          *ngIf="userRole == 'admin' || userRole == 'manager'"
        >
          <mat-form-field appearance="fill">
            <mat-label>Select Role</mat-label>
            <mat-select
              [(value)]="selectedRole"
              (selectionChange)="onSelectFilterUser($event)"
            >
              <mat-option *ngFor="let data of filterRole" [value]="data">
                {{ data | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<!-- <div>
  <mat-tab-group (selectedTabChange)="tabChanged($event)">
    <mat-tab label="Create User">
      <div style="margin: 0 auto;" class="dropdpwn-header-container">
        <span id="test1" class="select-company" style="width: 30%;" *ngIf="(userRole == 'root')">
          <mat-form-field appearance="fill">
            <mat-label>Select Company</mat-label>
            <mat-select [(value)]="selectedCompanyForFilter" (selectionChange)="onSelectcompany($event)">
              <mat-option *ngFor="let data of companyList" [value]="data">
                {{data.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      
        <span id="test2" class="select-role" *ngIf="(userRole == 'root')">
          <mat-form-field appearance="fill">
            <mat-label>Select Role</mat-label>
            <mat-select [(value)]="slelcted" (selectionChange)="onSelectCeateUser($event)">
              <mat-option *ngFor="let data of filterRole" [value]="data">
                {{data}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      
        <span id="test3" class="full-text">
          <button (click)= "openDialog()" mat-raised-button>New User</button>
        </span>
      </div>
    </mat-tab>
    <mat-tab label="Filter Users">
      <div style="margin: 0 auto;" class="dropdpwn-header-container">
        <span id="test1" class="select-company" style="width: 30%;" *ngIf="(userRole == 'root')">
          <mat-form-field appearance="fill">
            <mat-label>Select Company</mat-label>
            <mat-select [(value)]="selectedCompanyFilter" (selectionChange)="onSelectcompanyFilter()">
              <mat-option *ngFor="let data of companyList" [value]="data">
                {{data.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      
        <span id="test2" class="select-role" *ngIf="(userRole == 'admin')">
          <mat-form-field appearance="fill">
            <mat-label>Select Role</mat-label>
            <mat-select [(value)]="selectedRole" (selectionChange)="onSelectFilterUser($event)">
              <mat-option *ngFor="let data of filterRole" [value]="data">
                {{data | titlecase}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      </div>
    </mat-tab>
  </mat-tab-group>
</div> -->

<!-- <mat-spinner style="margin: auto;" *ngIf="showSpinner; else showContent" ></mat-spinner>
<ng-template #showContent>
  <div style="padding: 1.5vw;">
    <table class="table table-striped table-hover" data-row-style="rowStyle">
        <thead>
          <tr class="t-header">
            <th class="" scope="col">
              <div  class="actionPadding" title="Name">First Name</div>
            </th>
            <th class="" scope="col">
                <div  class="actionPadding" title="Name">Last Name</div>
              </th>
            <th class="" scope="col">
              <div title="Email">Email</div>
            </th>
            <th class="" scope="col">
              <div title="Phone">Phone</div>
            </th>
            <th class="" scope="col">
              <div class="actionLevel" title="Role">Role</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of filterUserList let indexOfelement=index;">
            <td>
                {{data.first_name | titlecase}}
            </td>
            <td>
                {{data.last_name | titlecase}}
            </td>
            <td>
                {{data.email}}
            </td>
            <td>
                {{data.phone}}
            </td>
            <td *ngIf="data.roles[0] == 'root' && userRole == 'admin'; else showDropdown">
              {{data.roles[0] | titlecase}}
            </td>
            <ng-template #showDropdown>
              <td *ngIf="userRole !='manager'">
                <mat-select [(value)]="data.roles[0]" (selectionChange)="updateUser(data)">
                  <mat-option *ngFor="let role of roles" [value]="role">
                    {{role | titlecase}}
                  </mat-option>
                </mat-select>
              </td>
              <td *ngIf="userRole == 'manager'">
                {{data.roles[0] | titlecase}}
              </td>
            </ng-template>
            
          </tr>
        </tbody>
    </table>
  </div>

  
</ng-template>  -->

<mat-spinner style="margin: auto" *ngIf="showSpinner"></mat-spinner>

<div
  class="mat-elevation-z8"
  style="padding: 2vw; margin-top: 1vw"
  [hidden]="showSpinner"
  matSort
>
  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="first_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
      <td mat-cell *matCellDef="let row">{{ row.first_name | titlecase }}</td>
    </ng-container>

    <ng-container matColumnDef="last_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
      <td mat-cell *matCellDef="let row">{{ row.last_name | titlecase }}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
      <td mat-cell *matCellDef="let row">{{ row.email }}</td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
      <td mat-cell *matCellDef="let row">{{ row.phone }}</td>
    </ng-container>

    <ng-container matColumnDef="division">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Division</th>
      <td mat-cell *matCellDef="let row">{{ row.division }}</td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>Edit</th>
      <td mat-cell *matCellDef="let row">
        <mat-icon (click)="handleEdit(row)">create</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th mat-header-cell *matHeaderCellDef>Delete</th>
      <td mat-cell *matCellDef="let row">
        <mat-icon (click)="deleteUser(row)">delete</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="roles">
      <th mat-header-cell *matHeaderCellDef>Roles</th>
      <td mat-cell *matCellDef="let row">
        <div *ngIf="userRole == 'manager'">
          {{ row.roles[0] | titlecase }}
        </div>
        <div *ngIf="userRole == 'admin'">
          <div *ngIf="row.roles[0] == 'root'; else showDropdownForAdmin">
            {{ row.roles[0] | titlecase }}
          </div>
          <ng-template #showDropdownForAdmin>
            <mat-select
              [(ngModel)]="row.roles[0]"
              (selectionChange)="updateUser(row)"
            >
              <mat-option *ngFor="let role of roles" [value]="role">
                {{ role | titlecase }}
              </mat-option>
            </mat-select>
          </ng-template>
        </div>
        <div *ngIf="userRole == 'root'">
          <mat-select
            [(ngModel)]="row.roles[0]"
            (selectionChange)="updateUser(row)"
          >
            <mat-option *ngFor="let role of roles" [value]="role">
              {{ role | titlecase }}
            </mat-option>
          </mat-select>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">
        No data matching the filter
        <span style="color: orangered">{{ searchText }}</span>
      </td>
    </tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 30]"></mat-paginator>
</div>
